/*
 * @Author: Pension 744056574@qq.com
 * @Date: 2022-09-09 11:16:11
 * @LastEditors: lihuiping lihuiping@yuouhui.com
 * @LastEditTime: 2024-06-19 15:11:19
 * @FilePath: /mmtv2-frontend-pc/packages/main/src/router/index.ts
 * @Description:路由
 *
 */

import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Login.vue"),
    meta: {
      title: "登录",
      quick: false,
    },
  },
  {
    path: "/findpwd",
    name: "findpwd",
    component: () => import("@/views/FindPassword.vue"),
    meta: {
      title: "找回密码",
      quick: false,
    },
  },
  {
    path: "/bigScreen",
    name: "bigScreen",
    component: () => import("@/views/BigScreen.vue"),
    meta: {
      title: "大屏数据",
      quick: false,
    },
  },
  {
    path: "/bigScreenShopActivityRate",
    name: "bigScreenShopActivityRate",
    component: () => import("@/views/bigScreenShopActivityRate.vue"),
    meta: {
      title: "大屏数据",
      quick: false,
    },
  },
  {
    path: "/agreement",
    name: "agreement",
    component: () => import("@/views/agreement.vue"),
    meta: {
      title: "用户协议",
      quick: false,
    },
  },
  /*************** #start h5 配置 *********************/
  {
    path: "/h5/trace-source/pdd/add",
    name: "h5-trace-source-pdd-add",
    component: () => import("../views/h5/trace-source/pdd/Add.vue"),
  },
  {
    path: "/h5/trace-source/member/add",
    name: "h5-trace-source-member-add",
    component: () => import("../views/h5/trace-source/member/Add.vue"),
  },
  {
    path: "/h5/trace-source/member/live",
    name: "h5-trace-source-member-live",
    component: () => import("../views/h5/trace-source/member/Live.vue"),
  },
  //  运营在飞书通知群通过这个H5进行改价的入口
  {
    path: "/h5/update-price/login",
    name: "h5-update-price-login",
    component: () => import("../views/h5/update-price/Login.vue"),
  },
  {
    path: "/h5/update-price/list",
    name: "h5-update-price-list",
    component: () => import("../views/h5/update-price/List.vue"),
  },
  {
    path: "/h5/update-price/success",
    name: "h5-update-price-success",
    component: () => import("../views/h5/update-price/Success.vue"),
  },
  /*************** #end h5 配置 *********************/
  {
    path: "/",
    name: "main",
    component: () => import("../views/Main.vue"),
    redirect: { name: "home" },
    children: [
      //首页
      {
        path: "/home",
        name: "home",
        component: () => import("../views/Home.vue"),
      },

      /*************** #start 系统权限管理 *********************/
      {
        path: "/zzmenu",
        name: "zzmenu",
        component: () => import("@/views/ZzMenu.vue"),
        meta: {
          title: "菜单配置",
          quick: false,
        },
      },
      {
        path: "/zzrole",
        name: "zzrole",
        component: () => import("@/views/ZzRole.vue"),
        meta: {
          title: "角色配置",
          quick: false,
        },
      },

      /*************** #end 系统权限管理 *********************/
      /*************** #start 基础中心 *********************/
      // 权限管理
      {
        path: "/base-center/permission-manage/role/list",
        name: "base-center-base-center-permission-manage-role-list",
        component: () => import("../views/base-center/permission-manage/role/List.vue"),
      },
      {
        path: "/base-center/permission-manage/role/add",
        name: "base-center-base-center-permission-manage-role-add",
        component: () => import("../views/base-center/permission-manage/role/Add.vue"),
      },
      {
        path: "/base-center/permission-manage/role/edit",
        name: "base-center-base-center-permission-manage-role-edit",
        component: () => import("../views/base-center/permission-manage/role/Add.vue"),
      },
      {
        path: "/base-center/permission-manage/user/list",
        name: "base-center-base-center-permission-manage-user-list",
        component: () => import("../views/base-center/permission-manage/user/List.vue"),
      },
      {
        path: "/base-center/permission-manage/user/add",
        name: "base-center-base-center-permission-manage-user-add",
        component: () => import("../views/base-center/permission-manage/user/Add.vue"),
      },
      {
        path: "/base-center/permission-manage/user/edit",
        name: "base-center-base-center-permission-manage-user-edit",
        component: () => import("../views/base-center/permission-manage/user/Add.vue"),
      },
      {
        path: "/base-center/permission-manage/user/view",
        name: "base-center-base-center-permission-manage-user-view",
        component: () => import("../views/base-center/permission-manage/user/View.vue"),
      },
      // 基础商品
      {
        path: "/base-center/base-goods/nation/list",
        name: "base-center-base-goods-nation-list",
        component: () => import("../views/base-center/base-goods/nation/List.vue"),
      },
      {
        path: "/base-center/base-goods/nation/add",
        name: "base-center-base-goods-nation-add",
        component: () => import("../views/base-center/base-goods/nation/Add.vue"),
      },
      {
        path: "/base-center/base-goods/nation/edit",
        name: "base-center-base-goods-nation-edit",
        component: () => import("../views/base-center/base-goods/nation/Add.vue"),
      },
      {
        path: "/base-center/base-goods/group/list",
        name: "base-center-base-goods-group-list",
        component: () => import("../views/base-center/base-goods/group/List.vue"),
      },
      {
        path: "/base-center/base-goods/group/add",
        name: "base-center-base-goods-group-add",
        component: () => import("../views/base-center/base-goods/group/Add.vue"),
      },
      {
        path: "/base-center/base-goods/group/edit",
        name: "base-center-base-goods-group-edit",
        component: () => import("../views/base-center/base-goods/group/Add.vue"),
      },
      {
        path: "/base-center/base-goods/brand/list",
        name: "base-center-base-goods-brand-list",
        component: () => import("../views/base-center/base-goods/brand/List.vue"),
      },
      {
        path: "/base-center/base-goods/brand/add",
        name: "base-center-base-goods-brand-add",
        component: () => import("../views/base-center/base-goods/brand/Add.vue"),
      },
      {
        path: "/base-center/base-goods/brand/edit",
        name: "base-center-base-goods-brand-edit",
        component: () => import("../views/base-center/base-goods/brand/Add.vue"),
      },
      {
        path: "/base-center/base-goods/goods-sold-out-notify/list",
        name: "base-center-base-goods-goods-sold-out-notify-list",
        component: () => import("../views/base-center/base-goods/goods-sold-out-notify/List.vue"),
      },
      {
        path: "/base-center/base-goods/control-goods-and-price-audit/list",
        name: "base-center-base-goods-control-goods-and-price-audit-list",
        component: () => import("../views/base-center/base-goods/control-goods-and-price-audit/List.vue"),
      },
      {
        path: "/base-center/base-goods/control-goods-and-price-audit/view",
        name: "base-center-base-goods-control-goods-and-price-audit-view",
        component: () => import("../views/base-center/base-goods/control-goods-and-price-audit/View.vue"),
      },
      {
        path: "/base-center/base-goods/control-goods-and-price/list",
        name: "base-center-base-goods-control-goods-and-price-list",
        component: () => import("../views/base-center/base-goods/control-goods-and-price/List.vue"),
      },
      {
        path: "/base-center/base-goods/control-goods-and-price/add",
        name: "base-center-base-goods-control-goods-and-price-add",
        component: () => import("../views/base-center/base-goods/control-goods-and-price/Add.vue"),
      },
      {
        path: "/base-center/base-goods/control-goods-and-price/edit",
        name: "base-center-base-goods-control-goods-and-price-edit",
        component: () => import("../views/base-center/base-goods/control-goods-and-price/Add.vue"),
      },
      {
        path: "/base-center/base-goods/control-goods-and-price/view",
        name: "base-center-base-goods-control-goods-and-price-view",
        component: () => import("../views/base-center/base-goods/control-goods-and-price/View.vue"),
      },
      {
        path: "/base-center/base-goods/label/list",
        name: "base-center-base-goods-label-list",
        component: () => import("../views/base-center/base-goods/label/List.vue"),
      },
      {
        path: "/base-center/base-goods/label/add",
        name: "base-center-base-goods-label-add",
        component: () => import("../views/base-center/base-goods/label/Add.vue"),
      },
      {
        path: "/base-center/base-goods/label/edit",
        name: "base-center-base-goods-label-edit",
        component: () => import("../views/base-center/base-goods/label/Add.vue"),
      },
      {
        path: "/base-center/base-goods/category/list",
        name: "base-center-base-goods-category-list",
        component: () => import("../views/base-center/base-goods/category/List.vue"),
      },
      {
        path: "/base-center/base-goods/attribute/list",
        name: "base-center-base-goods-attribute-list",
        component: () => import("../views/base-center/base-goods/attribute/List.vue"),
      },
      {
        path: "/base-center/base-goods/attribute/add",
        name: "base-center-base-goods-attribute-add",
        component: () => import("../views/base-center/base-goods/attribute/Add.vue"),
      },
      {
        path: "/base-center/base-goods/attribute/edit",
        name: "base-center-base-goods-attribute-edit",
        component: () => import("../views/base-center/base-goods/attribute/Add.vue"),
      },
      {
        path: "/base-center/base-goods/spu/list",
        name: "base-center-base-goods-spu-list",
        component: () => import("../views/base-center/base-goods/spu/List.vue"),
      },
      {
        path: "/base-center/base-goods/spu/add",
        name: "base-center-base-goods-spu-add",
        component: () => import("../views/base-center/base-goods/spu/Add.vue"),
      },
      {
        path: "/base-center/base-goods/spu/edit",
        name: "base-center-base-goods-spu-edit",
        component: () => import("../views/base-center/base-goods/spu/Add.vue"),
      },
      {
        path: "/base-center/base-goods/sku/list",
        name: "base-center-base-goods-sku-list",
        component: () => import("../views/base-center/base-goods/sku/List.vue"),
      },
      {
        path: "/base-center/base-goods/sku/edit-sale-config",
        name: "base-center-base-goods-sku-edit-sale-config",
        component: () => import("../views/base-center/base-goods/sku/EditSaleConfig.vue"),
      },
      {
        path: "/base-center/base-goods/sku/add",
        name: "base-center-base-goods-sku-add",
        component: () => import("../views/base-center/base-goods/sku/Add.vue"),
      },
      {
        path: "/base-center/base-goods/sku/edit",
        name: "/base-center/base-goods/sku/edit",
        component: () => import("../views/base-center/base-goods/sku/Add.vue"),
      },
      {
        path: "/base-center/base-goods/sku/view",
        name: "base-center-base-goods-sku-view",
        component: () => import("../views/base-center/base-goods/sku/View.vue"),
      },
      {
        path: "/base-center/base-goods/sku/edit-price",
        name: "/base-center/base-goods/sku/edit-price",
        component: () => import("../views/base-center/base-goods/sku/BatchUpdatePrice.vue"),
      },
      {
        path: "/base-center/base-goods/sku/edit-status",
        name: "/base-center/base-goods/sku/edit-status",
        component: () => import("../views/base-center/base-goods/sku/BatchUpdateStatus.vue"),
      },
      {
        path: "/base-center/base-goods/sku/updatePriceLog/list",
        name: "base-center-base-goods-sku-updatePriceLog-list",
        component: () => import("../views/base-center/base-goods/sku/updatePriceLog/List.vue"),
      },
      {
        path: "/base-center/base-goods/sku/updatePriceLog/view",
        name: "base-center-base-goods-sku-updatePriceLog-view",
        component: () => import("../views/base-center/base-goods/sku/updatePriceLog/View.vue"),
      },
      {
        path: "/base-center/base-goods/sku/updatePriceRule/list",
        name: "base-center-base-goods-sku-updatePriceRule-list",
        component: () => import("../views/base-center/base-goods/sku/updatePriceRule/List.vue"),
      },
      //   {
      //     path: "/base-center/base-goods/sku/updatePriceRule/add",
      //     name: "base-center-base-goods-sku-updatePriceRule-add",
      //     component: () => import("../views/base-center/base-goods/sku/updatePriceRule/Add.vue"),
      //   },

      {
        path: "/base-center/base-goods/sku/updatePriceRule/view",
        name: "base-center-base-goods-sku-updatePriceRule-view",
        component: () => import("../views/base-center/base-goods/sku/updatePriceRule/View.vue"),
      },
      {
        path: "/base-center/base-goods/batch/list",
        name: "base-center-base-goods-batch-list",
        component: () => import("../views/base-center/base-goods/batch/List.vue"),
      },
      {
        path: "/base-center/base-goods/batch/add",
        name: "base-center-base-goods-batch-add",
        component: () => import("../views/base-center/base-goods/batch/Add.vue"),
      },
      {
        path: "/base-center/base-goods/batch/view",
        name: "base-center-base-goods-batch-view",
        component: () => import("../views/base-center/base-goods/batch/View.vue"),
      },
      {
        path: "/base-center/base-goods/evaluation/list",
        name: "base-center-base-goods-evaluation-list",
        component: () => import("../views/base-center/base-goods/evaluation/List.vue"),
      },
      {
        path: "/base-center/base-goods/evaluation/list",
        name: "base-center-base-goods-evaluation-list",
        component: () => import("../views/base-center/base-goods/evaluation/List.vue"),
      },
      {
        path: "/base-center/base-goods/quota/list",
        name: "base-center-stock-quota-quota-list",
        component: () => import("../views/base-center/base-goods/quota/List.vue"),
      },
      {
        path: "/base-center/base-goods/quota/add",
        name: "base-center-stock-quota-quota-add",
        component: () => import("../views/base-center/base-goods/quota/Add.vue"),
      },
      {
        path: "/base-center/base-goods/quota/edit",
        name: "base-center-stock-quota-quota-edit",
        component: () => import("../views/base-center/base-goods/quota/Add.vue"),
      },
      {
        path: "/base-center/base-goods/quota/view",
        name: "base-center-stock-quota-quota-view",
        component: () => import("../views/base-center/base-goods/quota/View.vue"),
      },
      // 库位运费
      {
        path: "/base-center/warhouse-freight/warhouse/list",
        name: "base-center-warhouse-freight-warhouse-list",
        component: () => import("../views/base-center/warhouse-freight/warhouse/List.vue"),
      },
      {
        path: "/base-center/warhouse-freight/warhouse/add",
        name: "base-center-warhouse-freight-warhouse-add",
        component: () => import("../views/base-center/warhouse-freight/warhouse/Add.vue"),
      },
      {
        path: "/base-center/warhouse-freight/warhouse/edit",
        name: "base-center-warhouse-freight-warhouse-edit",
        component: () => import("../views/base-center/warhouse-freight/warhouse/Add.vue"),
      },
      {
        path: "/base-center/warhouse-freight/freight/list",
        name: "base-center-warhouse-freight-freight-list",
        component: () => import("../views/base-center/warhouse-freight/freight/List.vue"),
      },
      {
        path: "/base-center/warhouse-freight/freight/add",
        name: "base-center-warhouse-freight-freight-add",
        component: () => import("../views/base-center/warhouse-freight/freight/Add.vue"),
      },
      {
        path: "/base-center/warhouse-freight/freight/edit",
        name: "base-center-warhouse-freight-freight-edit",
        component: () => import("../views/base-center/warhouse-freight/freight/Add.vue"),
      },
      // 大区管理
      {
        path: "/base-center/user-manage/region-manage/list",
        name: "base-center-user-manage-region-manage-list",
        component: () => import("../views/base-center/user-manage/region-manage/List.vue"),
      },
      {
        path: "/base-center/user-manage/region-manage/add",
        name: "base-center-user-manage-region-manage-add",
        component: () => import("../views/base-center/user-manage/region-manage/Add.vue"),
      },
      {
        path: "/base-center/user-manage/region-manage/edit",
        name: "base-center-user-manage-region-manage-edit",
        component: () => import("../views/base-center/user-manage/region-manage/Add.vue"),
      },
      {
        path: "/base-center/user-manage/region-manage/view",
        name: "base-center-user-manage-region-manage-view",
        component: () => import("../views/base-center/user-manage/region-manage/View.vue"),
      },
      //   服务站管理
      {
        path: "/base-center/user-manage/service-manage/list",
        name: "base-center-user-manage-service-manage-list",
        component: () => import("../views/base-center/user-manage/service-manage/List.vue"),
      },
      {
        path: "/base-center/user-manage/service-manage/add",
        name: "base-center-user-manage-service-manage-add",
        component: () => import("../views/base-center/user-manage/service-manage/Add.vue"),
      },
      {
        path: "/base-center/user-manage/service-manage/edit",
        name: "base-center-user-manage-service-manage-edit",
        component: () => import("../views/base-center/user-manage/service-manage/Add.vue"),
      },
      {
        path: "/base-center/user-manage/service-manage/view",
        name: "base-center-user-manage-service-manage-view",
        component: () => import("../views/base-center/user-manage/service-manage/View.vue"),
      },
      //   业务员管理
      {
        path: "/base-center/user-manage/dsr-manage/list",
        name: "base-center-user-manage-dsr-manage-list",
        component: () => import("../views/base-center/user-manage/dsr-manage/List.vue"),
      },
      {
        path: "/base-center/user-manage/dsr-manage/add",
        name: "base-center-user-manage-dsr-manage-add",
        component: () => import("../views/base-center/user-manage/dsr-manage/Add.vue"),
      },
      {
        path: "/base-center/user-manage/dsr-manage/edit",
        name: "base-center-user-manage-dsr-manage-edit",
        component: () => import("../views/base-center/user-manage/dsr-manage/Add.vue"),
      },
      {
        path: "/base-center/user-manage/dsr-manage/view",
        name: "base-center-user-manage-dsr-manage-view",
        component: () => import("../views/base-center/user-manage/dsr-manage/View.vue"),
      },
      //连锁
      {
        path: "/base-center/user-manage/chain-manage/list",
        name: "base-center-user-manage-chain-manage-list",
        component: () => import("../views/base-center/user-manage/chain-manage/List.vue"),
      },
      {
        path: "/base-center/user-manage/chain-manage/add",
        name: "base-center-user-manage-chain-manage-add",
        component: () => import("../views/base-center/user-manage/chain-manage/Add.vue"),
      },
      {
        path: "/base-center/user-manage/chain-manage/edit",
        name: "base-center-user-manage-chain-manage-edit",
        component: () => import("../views/base-center/user-manage/chain-manage/Add.vue"),
      },
      {
        path: "/base-center/user-manage/chain-manage/view",
        name: "base-center-user-manage-chain-manage-view",
        component: () => import("../views/base-center/user-manage/chain-manage/View.vue"),
      },
      //   门店等级
      {
        path: "/base-center/user-manage/shop-level/list",
        name: "base-center-user-manage-shop-level-list",
        component: () => import("../views/base-center/user-manage/shop-level/List.vue"),
      },
      {
        path: "/base-center/user-manage/shop-level/add",
        name: "base-center-user-manage-shop-level-add",
        component: () => import("../views/base-center/user-manage/shop-level/Add.vue"),
      },
      {
        path: "/base-center/user-manage/shop-level/edit",
        name: "base-center-user-manage-shop-level-edit",
        component: () => import("../views/base-center/user-manage/shop-level/Add.vue"),
      },
      {
        path: "/base-center/user-manage/shop-level/view",
        name: "base-center-user-manage-shop-level-view",
        component: () => import("../views/base-center/user-manage/shop-level/View.vue"),
      },
      //门店等级评级
      {
        path: "/base-center/user-manage/shop-rating/list",
        name: "base-center-user-manage-shop-rating-list",
        component: () => import("../views/base-center/user-manage/shop-rating/List.vue"),
      },
      //邀请码
      {
        path: "/base-center/user-manage/invitation-code/list",
        name: "base-center-user-manage-invitation-code-list",
        component: () => import("../views/base-center/user-manage/invitation-code/List.vue"),
      },
      {
        path: "/base-center/user-manage/invitation-code/add",
        name: "base-center-user-manage-invitation-code-add",
        component: () => import("../views/base-center/user-manage/invitation-code/Add.vue"),
      },
      {
        path: "/base-center/user-manage/invitation-code/edit",
        name: "base-center-user-manage-invitation-code-edit",
        component: () => import("../views/base-center/user-manage/invitation-code/Add.vue"),
      },
      {
        path: "/base-center/user-manage/invitation-code/view",
        name: "base-center-user-manage-invitation-code-view",
        component: () => import("../views/base-center/user-manage/invitation-code/View.vue"),
      },
      //门店管理
      {
        path: "/base-center/user-manage/shop-manage/list",
        name: "base-center-user-manage-shop-manage-list",
        component: () => import("../views/base-center/user-manage/shop-manage/List.vue"),
      },
      {
        path: "/base-center/user-manage/shop-manage/add",
        name: "base-center-user-manage-shop-manage-add",
        component: () => import("../views/base-center/user-manage/shop-manage/Add.vue"),
      },
      {
        path: "/base-center/user-manage/shop-manage/edit",
        name: "base-center-user-manage-shop-manage-edit",
        component: () => import("../views/base-center/user-manage/shop-manage/Add.vue"),
      },
      {
        path: "/base-center/user-manage/shop-manage/view",
        name: "base-center-user-manage-shop-manage-view",
        component: () => import("../views/base-center/user-manage/shop-manage/View.vue"),
      },
      //发票管理
      {
        path: "/base-center/user-manage/invoice-manage/list",
        name: "base-center-user-manage-invoice-manage-list",
        component: () => import("../views/base-center/user-manage/invoice-manage/List.vue"),
      },
      {
        path: "/base-center/user-manage/invoice-manage/add",
        name: "base-center-user-manage-invoice-manage-add",
        component: () => import("../views/base-center/user-manage/invoice-manage/Add.vue"),
      },
      {
        path: "/base-center/user-manage/invoice-manage/edit",
        name: "base-center-user-manage-invoice-manage-edit",
        component: () => import("../views/base-center/user-manage/invoice-manage/Add.vue"),
      },
      {
        path: "/base-center/user-manage/invoice-manage/view",
        name: "base-center-user-manage-invoice-manage-view",
        component: () => import("../views/base-center/user-manage/invoice-manage/View.vue"),
      },
      //员工管理
      {
        path: "/base-center/user-manage/staff-manage/list",
        name: "base-center-user-manage-staff-manage-list",
        component: () => import("../views/base-center/user-manage/staff-manage/List.vue"),
      },
      {
        path: "/base-center/user-manage/staff-manage/add",
        name: "base-center-user-manage-staff-manage-add",
        component: () => import("../views/base-center/user-manage/staff-manage/Add.vue"),
      },
      {
        path: "/base-center/user-manage/staff-manage/edit",
        name: "base-center-user-manage-staff-manage-edit",
        component: () => import("../views/base-center/user-manage/staff-manage/Add.vue"),
      },
      {
        path: "/base-center/user-manage/staff-manage/view",
        name: "base-center-user-manage-staff-manage-view",
        component: () => import("../views/base-center/user-manage/staff-manage/View.vue"),
      },
      //会员列表
      {
        path: "/base-center/user-manage/member-manage/list",
        name: "base-center-user-manage-member-manage-list",
        component: () => import("../views/base-center/user-manage/member-manage/List.vue"),
      },
      {
        path: "/base-center/user-manage/member-manage/view",
        name: "base-center-user-manage-member-manage-view",
        component: () => import("../views/base-center/user-manage/member-manage/View.vue"),
      },

      {
        path: "/base-center/user-manage/shop-convey/list",
        name: "base-center-user-manage-shop-convey-list",
        component: () => import("../views/base-center/user-manage/shop-convey/List.vue"),
      },
      {
        path: "/base-center/user-manage/shop-convey/view",
        name: "base-center-user-manage-shop-convey-view",
        component: () => import("../views/base-center/user-manage/shop-convey/View.vue"),
      },



      //   系统配置
      {
        path: "/base-center/system-configuration/download/list",
        name: "base-center-system-configuration-download-list",
        component: () => import("../views/base-center/system-configuration/download/List.vue"),
      },
      {
        path: "/base-center/system-configuration/commission-rule/list",
        name: "base-center-system-configuration-commission-rule-list",
        component: () => import("../views/base-center/system-configuration/commission-rule/List.vue"),
      },
      {
        path: "/base-center/system-configuration/commission-rule/add",
        name: "base-center-system-configuration-commission-rule-add",
        component: () => import("../views/base-center/system-configuration/commission-rule/Add.vue"),
      },
      {
        path: "/base-center/system-configuration/commission-rule/edit",
        name: "base-center-system-configuration-commission-rule-edit",
        component: () => import("../views/base-center/system-configuration/commission-rule/Add.vue"),
      },
      {
        path: "/base-center/system-configuration/commission-rule/view",
        name: "base-center-system-configuration-commission-rule-view",
        component: () => import("../views/base-center/system-configuration/commission-rule/View.vue"),
      },
      {
        path: "/base-center/system-configuration/system-rule/list",
        name: "base-center-system-configuration-system-rule-list",
        component: () => import("../views/base-center/system-configuration/system-rule/List.vue"),
      },
      //平台协议
      {
        path: "/base-center/system-configuration/platform-agreement/list",
        name: "base-center-system-configuration-platform-agreement-list",
        component: () => import("../views/base-center/system-configuration/platform-agreement/List.vue"),
      },
      {
        path: "/base-center/system-configuration/platform-agreement/edit",
        name: "base-center-system-configuration-platform-agreement-edit",
        component: () => import("../views/base-center/system-configuration/platform-agreement/Add.vue"),
      },
      //app版本管理
      {
        path: "/base-center/system-configuration/APP-version/list",
        name: "base-center-system-configuration-APP-version-list",
        component: () => import("../views/base-center/system-configuration/APP-version/List.vue"),
      },
      {
        path: "/base-center/system-configuration/APP-version/add",
        name: "base-center-system-configuration-APP-version-add",
        component: () => import("../views/base-center/system-configuration/APP-version/Add.vue"),
      },
      //扫码激励
      {
        path: "/base-center/system-configuration/scancode-incentive/list",
        name: "base-center-system-configuration-scancode-incentive-list",
        component: () => import("../views/base-center/system-configuration/scancode-incentive/List.vue"),
      },
      {
        path: "/base-center/system-configuration/scancode-incentive/add",
        name: "base-center/system-configuration/scancode-incentive-add",
        component: () => import("../views/base-center/system-configuration/scancode-incentive/Add.vue"),
      },
      {
        path: "/base-center/system-configuration/scancode-incentive/edit",
        name: "base-center/system-configuration/scancode-incentive-edit",
        component: () => import("../views/base-center/system-configuration/scancode-incentive/Add.vue"),
      },
      {
        path: "/base-center/system-configuration/scancode-incentive/view",
        name: "base-center/system-configuration/scancode-incentive-view",
        component: () => import("../views/base-center/system-configuration/scancode-incentive/View.vue"),
      },

      /*************** #end 基础中心 *********************/
      /*************** #start 零售中心 *********************/
      //   商品管理
      {
        path: "/retail-center/goods-manage/retail-goods/list",
        name: "retail-center-goods-manage-retail-goods-list",
        component: () => import("../views/retail-center/goods-manage/retail-goods/List.vue"),
      },
      {
        path: "/retail-center/goods-manage/retail-goods/add",
        name: "retail-center-goods-manage-retail-goods-add",
        component: () => import("../views/retail-center/goods-manage/retail-goods/Add.vue"),
      },
      {
        path: "/retail-center/goods-manage/retail-goods/edit",
        name: "retail-center-goods-manage-retail-goods-edit",
        component: () => import("../views/retail-center/goods-manage/retail-goods/Add.vue"),
      },
      {
        path: "/retail-center/goods-manage/retail-goods/view",
        name: "retail-center-goods-manage-retail-goods-view",
        component: () => import("../views/retail-center/goods-manage/retail-goods/View.vue"),
      },
      //   产品线
      {
        path: "/retail-center/goods-manage/product-line/list",
        name: "retail-center-goods-manage-product-line-list",
        component: () => import("../views/retail-center/goods-manage/product-line/List.vue"),
      },
      {
        path: "/retail-center/goods-manage/product-line/add",
        name: "retail-center-goods-manage-product-line-add",
        component: () => import("../views/retail-center/goods-manage/product-line/Add.vue"),
      },
      {
        path: "/retail-center/goods-manage/product-line/edit",
        name: "retail-center-goods-manage-product-line-edit",
        component: () => import("../views/retail-center/goods-manage/product-line/Add.vue"),
      },
      {
        path: "/retail-center/goods-manage/product-line/view",
        name: "retail-center-goods-manage-product-line-view",
        component: () => import("../views/retail-center/goods-manage/product-line/View.vue"),
      },
      //   备案信息
      {
        path: "/retail-center/goods-manage/record-info/list",
        name: "retail-center-goods-manage-record-info-list",
        component: () => import("../views/retail-center/goods-manage/record-info/List.vue"),
      },
      {
        path: "/retail-center/goods-manage/record-info/add",
        name: "retail-center-goods-manage-record-info-add",
        component: () => import("../views/retail-center/goods-manage/record-info/Add.vue"),
      },
      {
        path: "/retail-center/goods-manage/record-info/edit",
        name: "retail-center-goods-manage-record-info-edit",
        component: () => import("../views/retail-center/goods-manage/record-info/Add.vue"),
      },
      {
        path: "/retail-center/goods-manage/record-info/view",
        name: "retail-center-goods-manage-record-info-view",
        component: () => import("../views/retail-center/goods-manage/record-info/View.vue"),
      },
      //   库存配额
      {
        path: "/retail-center/stock-quota/stock/list",
        name: "retail-center-stock-quota-stock-list",
        component: () => import("../views/retail-center/stock-quota/stock/List.vue"),
      },
      {
        path: "/retail-center/stock-quota/stock/add",
        name: "retail-center-stock-quota-stock-add",
        component: () => import("../views/retail-center/stock-quota/stock/Add.vue"),
      },
      {
        path: "/retail-center/stock-quota/stock/edit",
        name: "retail-center-stock-quota-stock-edit",
        component: () => import("../views/retail-center/stock-quota/stock/Add.vue"),
      },
      {
        path: "/retail-center/stock-quota/stock/view",
        name: "retail-center-stock-quota-stock-view",
        component: () => import("../views/retail-center/stock-quota/stock/View.vue"),
      },
      {
        path: "/retail-center/stock-quota/quota/list",
        name: "retail-center-stock-quota-quota-list",
        component: () => import("../views/retail-center/stock-quota/quota/List.vue"),
      },
      {
        path: "/retail-center/stock-quota/quota/add",
        name: "retail-center-stock-quota-quota-add",
        component: () => import("../views/retail-center/stock-quota/quota/Add.vue"),
      },
      {
        path: "/retail-center/stock-quota/quota/edit",
        name: "retail-center-stock-quota-quota-edit",
        component: () => import("../views/retail-center/stock-quota/quota/Add.vue"),
      },
      {
        path: "/retail-center/stock-quota/quota/view",
        name: "retail-center-stock-quota-quota-view",
        component: () => import("../views/retail-center/stock-quota/quota/View.vue"),
      },

      //订单管理
      {
        path: "/retail-center/transaction-management/order-list/list",
        name: "retail-center-transaction-management-order-list-list",
        component: () => import("../views/retail-center/transaction-management/order-list/List.vue"),
      },
      {
        path: "/retail-center/transaction-management/order-list/view",
        name: "retail-center-transaction-management-order-list-view",
        component: () => import("../views/retail-center/transaction-management/order-list/View.vue"),
      },
      //零售订单
      {
        path: "/retail-center/transaction-management/order/list",
        name: "retail-center-transaction-management-order-list",
        component: () => import("../views/retail-center/transaction-management/order/List.vue"),
      },

      {
        path: "/retail-center/transaction-management/order/view",
        name: "retail-center-transaction-management-order-view",
        component: () => import("../views/retail-center/transaction-management/order/View.vue"),
      },

      //零售退单
      {
        path: "/retail-center/transaction-management/chargebacks/add",
        name: "retail-center-transaction-management-chargebacks-add",
        component: () => import("../views/retail-center/transaction-management/chargebacks/Add.vue"),
      },
      {
        path: "/retail-center/transaction-management/chargebacks/list",
        name: "retail-center-transaction-management-chargebacks-list",
        component: () => import("../views/retail-center/transaction-management/chargebacks/List.vue"),
      },

      {
        path: "/retail-center/transaction-management/chargebacks/view",
        name: "retail-center-transaction-management-chargebacks-view",
        component: () => import("../views/retail-center/transaction-management/chargebacks/View.vue"),
      },

      /*************** #end 零售中心 *********************/
      /*************** #start 分销中心 *********************/
      // 商品管理
      {
        path: "/distribution-center/goods-manage/distribution-goods/list",
        name: "distribution-center-goods-manage-distribution-goods-list",
        component: () => import("../views/distribution-center/goods-manage/distribution-goods/List.vue"),
      },
      {
        path: "/distribution-center/goods-manage/distribution-goods/add",
        name: "distribution-center-goods-manage-distribution-goods-add",
        component: () => import("../views/distribution-center/goods-manage/distribution-goods/Add.vue"),
      },
      {
        path: "/distribution-center/goods-manage/distribution-goods/edit",
        name: "distribution-center-goods-manage-distribution-goods-edit",
        component: () => import("../views/distribution-center/goods-manage/distribution-goods/Add.vue"),
      },
      {
        path: "/distribution-center/goods-manage/distribution-goods/view",
        name: "distribution-center-goods-manage-distribution-goods-view",
        component: () => import("../views/distribution-center/goods-manage/distribution-goods/View.vue"),
      },

      //库存配额
      {
        path: "/distribution-center/stock-quota/stock/list",
        name: "distribution-center-stock-quota-stock-list",
        component: () => import("../views/distribution-center/stock-quota/stock/List.vue"),
      },
      {
        path: "/distribution-center/stock-quota/stock/add",
        name: "distribution-center-stock-quota-stock-add",
        component: () => import("../views/distribution-center/stock-quota/stock/Add.vue"),
      },
      {
        path: "/distribution-center/stock-quota/stock/edit",
        name: "distribution-center-stock-quota-stock-edit",
        component: () => import("../views/distribution-center/stock-quota/stock/Add.vue"),
      },
      {
        path: "/distribution-center/stock-quota/stock/view",
        name: "distribution-center-stock-quota-stock-view",
        component: () => import("../views/distribution-center/stock-quota/stock/View.vue"),
      },
      {
        path: "/distribution-center/stock-quota/quota/list",
        name: "distribution-center-stock-quota-quota-list",
        component: () => import("../views/distribution-center/stock-quota/quota/List.vue"),
      },
      {
        path: "/distribution-center/stock-quota/quota/add",
        name: "distribution-center-stock-quota-quota-add",
        component: () => import("../views/distribution-center/stock-quota/quota/Add.vue"),
      },
      {
        path: "/distribution-center/stock-quota/quota/edit",
        name: "distribution-center-stock-quota-quota-edit",
        component: () => import("../views/distribution-center/stock-quota/quota/Add.vue"),
      },
      {
        path: "/distribution-center/stock-quota/quota/view",
        name: "distribution-center-stock-quota-quota-view",
        component: () => import("../views/distribution-center/stock-quota/quota/View.vue"),
      },

      // 交易管理
      //支付配置
      {
        path: "/distribution-center/transaction-management/pay/list",
        name: "distribution-center-transaction-management-pay-list",
        component: () => import("../views/distribution-center/transaction-management/pay/List.vue"),
      },

      //异常订单
      {
        path: "/distribution-center/transaction-management/error-order/list",
        name: "distribution-center-transaction-management-error-order-list",
        component: () => import("../views/distribution-center/transaction-management/error-order/List.vue"),
      },

      //分销订单
      {
        path: "/distribution-center/transaction-management/order/list",
        name: "distribution-center-transaction-management-order-list",
        component: () => import("../views/distribution-center/transaction-management/order/List.vue"),
      },

      {
        path: "/distribution-center/transaction-management/order/view",
        name: "distribution-center-transaction-management-order-view",
        component: () => import("../views/distribution-center/transaction-management/order/View.vue"),
      },

      //分销退单
      {
        path: "/distribution-center/transaction-management/chargebacks/add",
        name: "distribution-center-transaction-management-chargebacks-add",
        component: () => import("../views/distribution-center/transaction-management/chargebacks/Add.vue"),
      },
      {
        path: "/distribution-center/transaction-management/chargebacks/list",
        name: "distribution-center-transaction-management-chargebacks-list",
        component: () => import("../views/distribution-center/transaction-management/chargebacks/List.vue"),
      },

      {
        path: "/distribution-center/transaction-management/chargebacks/view",
        name: "distribution-center-transaction-management-chargebacks-view",
        component: () => import("../views/distribution-center/transaction-management/chargebacks/View.vue"),
      },
      //风险订单规则
      {
        path: "/distribution-center/transaction-management/risk-order/add",
        name: "distribution-center-transaction-management-risk-order-add",
        component: () => import("../views/distribution-center/transaction-management/risk-order/Add.vue"),
      },
      {
        path: "/distribution-center/transaction-management/risk-order/edit",
        name: "distribution-center-transaction-management-risk-order-edit",
        component: () => import("../views/distribution-center/transaction-management/risk-order/Add.vue"),
      },
      {
        path: "/distribution-center/transaction-management/risk-order/list",
        name: "distribution-center-transaction-management-risk-order-list",
        component: () => import("../views/distribution-center/transaction-management/risk-order/List.vue"),
      },

      {
        path: "/distribution-center/transaction-management/risk-order/view",
        name: "distribution-center-transaction-management-risk-order-view",
        component: () => import("../views/distribution-center/transaction-management/risk-order/View.vue"),
      },
      /*************** #end 分销中心 *********************/
      /*************** #start 运营中心 *********************/
      {
        path: "/operate-center/trace-source/pdd/list",
        name: "operate-center-trace-source-pdd-list",
        component: () => import("../views/operate-center/trace-source/pdd/List.vue"),
      },
      {
        path: "/operate-center/trace-source/member/list",
        name: "operate-center-trace-source-member-list",
        component: () => import("../views/operate-center/trace-source/member/List.vue"),
      },
      // B端促销活动 - 陈列PK赛
      {
        path: "/operate-center/toB-activity/store-pk-competition/list",
        name: "operate-center-toB-activity-store-pk-competition-list",
        component: () => import("../views/operate-center/toB-activity/store-pk-competition/List.vue"),
      },
      {
        path: "/operate-center/toB-activity/store-pk-competition/add",
        name: "operate-center-toB-activity-store-pk-competition-add",
        component: () => import("../views/operate-center/toB-activity/store-pk-competition/Add.vue"),
      },
      {
        path: "/operate-center/toB-activity/store-pk-competition/edit",
        name: "operate-center-toB-activity-store-pk-competition-edit",
        component: () => import("../views/operate-center/toB-activity/store-pk-competition/Add.vue"),
      },
      {
        path: "/operate-center/toB-activity/store-pk-competition/view",
        name: "operate-center-toB-activity-store-pk-competition-view",
        component: () => import("../views/operate-center/toB-activity/store-pk-competition/View.vue"),
      },
      //   陈列pk赛报名- 详情
      {
        path: "/operate-center/toB-activity/store-pk-competition/sign-up-view",
        name: "operate-center-toB-activity-store-pk-competition-sign-up-view",
        component: () => import("../views/operate-center/toB-activity/store-pk-competition/SignUpView.vue"),
      },
      // B端促销活动 - 组合活动
      {
        path: "/operate-center/toB-activity/combine-activity/list",
        name: "operate-center-toB-activity-combine-activity-list",
        component: () => import("../views/operate-center/toB-activity/combine-activity/List.vue"),
      },
      {
        path: "/operate-center/toB-activity/combine-activity/add",
        name: "operate-center-toB-activity-combine-activity-add",
        component: () => import("../views/operate-center/toB-activity/combine-activity/Add.vue"),
      },
      {
        path: "/operate-center/toB-activity/combine-activity/edit",
        name: "operate-center-toB-activity-combine-activity-edit",
        component: () => import("../views/operate-center/toB-activity/combine-activity/Add.vue"),
      },
      {
        path: "/operate-center/toB-activity/combine-activity/view",
        name: "operate-center-toB-activity-combine-activity-view",
        component: () => import("../views/operate-center/toB-activity/combine-activity/View.vue"),
      },
      // B端促销活动 - 礼品券
      {
        path: "/operate-center/toB-activity/gift-coupon/list",
        name: "operate-center-toB-activity-gift-coupon-list",
        component: () => import("../views/operate-center/toB-activity/gift-coupon/List.vue"),
      },
      {
        path: "/operate-center/toB-activity/gift-coupon/add",
        name: "operate-center-toB-activity-gift-coupon-add",
        component: () => import("../views/operate-center/toB-activity/gift-coupon/Add.vue"),
      },
      {
        path: "/operate-center/toB-activity/gift-coupon/edit",
        name: "operate-center-toB-activity-gift-coupon-edit",
        component: () => import("../views/operate-center/toB-activity/gift-coupon/Add.vue"),
      },
      {
        path: "/operate-center/toB-activity/gift-coupon/view",
        name: "operate-center-toB-activity-gift-coupon-view",
        component: () => import("../views/operate-center/toB-activity/gift-coupon/View.vue"),
      },
      // B端促销活动 - 礼品券核销
      {
        path: "/operate-center/toB-activity/gift-coupon-verification/list",
        name: "operate-center-toB-activity-gift-coupon-verification-list",
        component: () => import("../views/operate-center/toB-activity/gift-coupon-verification/List.vue"),
      },
      {
        path: "/operate-center/toB-activity/gift-coupon-verification/view",
        name: "operate-center-toB-activity-gift-coupon-verification-view",
        component: () => import("../views/operate-center/toB-activity/gift-coupon-verification/View.vue"),
      },
      //c端优惠券
      {
        path: "/operate-center/customer-coupon/coupon-code/list",
        name: "operate-center-customer-coupon-coupon-code-list",
        component: () => import("../views/operate-center/customer-coupon/coupon-code/List.vue"),
      },
      {
        path: "/operate-center/customer-coupon/coupon/list",
        name: "operate-center-customer-coupon-coupon-list",
        component: () => import("../views/operate-center/customer-coupon/coupon/List.vue"),
      },
      {
        path: "/operate-center/customer-coupon/coupon/add",
        name: "operate-center-customer-coupon-coupon-add",
        component: () => import("../views/operate-center/customer-coupon/coupon/Add.vue"),
      },
      {
        path: "/operate-center/customer-coupon/coupon/edit",
        name: "operate-center-customer-coupon-coupon-edit",
        component: () => import("../views/operate-center/customer-coupon/coupon/Add.vue"),
      },
      {
        path: "/operate-center/customer-coupon/coupon/edit-delivery",
        name: "operate-center-customer-coupon-coupon-edit-delivery",
        component: () => import("../views/operate-center/customer-coupon/coupon/Delivery.vue"),
      },
      {
        path: "/operate-center/customer-coupon/coupon/view",
        name: "operate-center-customer-coupon-coupon-view",
        component: () => import("../views/operate-center/customer-coupon/coupon/View.vue"),
      },
      {
        path: "/operate-center/customer-coupon/coupon-grant/list",
        name: "operate-center-customer-coupon-coupon-grant-list",
        component: () => import("../views/operate-center/customer-coupon/coupon-grant/List.vue"),
      },

      // B端优惠券
      {
        path: "/operate-center/shop-coupon/coupon/list",
        name: "operate-center-shop-coupon-coupon-list",
        component: () => import("../views/operate-center/shop-coupon/coupon/List.vue"),
      },
      {
        path: "/operate-center/shop-coupon/coupon/add",
        name: "operate-center-shop-coupon-coupon-add",
        component: () => import("../views/operate-center/shop-coupon/coupon/Add.vue"),
      },
      {
        path: "/operate-center/shop-coupon/coupon/edit",
        name: "operate-center-shop-coupon-coupon-edit",
        component: () => import("../views/operate-center/shop-coupon/coupon/Add.vue"),
      },
      {
        path: "/operate-center/shop-coupon/coupon/view",
        name: "operate-center-shop-coupon-coupon-view",
        component: () => import("../views/operate-center/shop-coupon/coupon/View.vue"),
      },
      {
        path: "/operate-center/shop-coupon/coupon-grant/list",
        name: "operate-center-shop-coupon-coupon-grant-list",
        component: () => import("../views/operate-center/shop-coupon/coupon-grant/List.vue"),
      },

      // 消息广告
      {
        path: "/operate-center/message-ad/app-ad/list",
        name: "operate-center-message-ad-app-ad-list",
        component: () => import("../views/operate-center/message-ad/app-ad/List.vue"),
      },
      {
        path: "/operate-center/message-ad/app-ad/add",
        name: "operate-center-message-ad-app-ad-add",
        component: () => import("../views/operate-center/message-ad/app-ad/Add.vue"),
      },
      {
        path: "/operate-center/message-ad/app-ad/edit",
        name: "operate-center-message-ad-app-ad-edit",
        component: () => import("../views/operate-center/message-ad/app-ad/Add.vue"),
      },
      {
        path: "/operate-center/message-ad/mp-ad/list",
        name: "operate-center-message-ad-mp-ad-list",
        component: () => import("../views/operate-center/message-ad/mp-ad/List.vue"),
      },
      {
        path: "/operate-center/message-ad/mp-ad/add",
        name: "operate-center-message-ad-mp-ad-add",
        component: () => import("../views/operate-center/message-ad/mp-ad/Add.vue"),
      },
      {
        path: "/operate-center/message-ad/mp-ad/edit",
        name: "operate-center-message-ad-mp-ad-edit",
        component: () => import("../views/operate-center/message-ad/mp-ad/Add.vue"),
      },
      //消息通知
      {
        path: "/operate-center/message-ad/message-notification/list",
        name: "operate-center-message-ad-message-notification-list",
        component: () => import("../views/operate-center/message-ad/message-notification/List.vue"),
      },
      {
        path: "/operate-center/message-ad/message-notification/add",
        name: "operate-center-message-ad-message-notification-add",
        component: () => import("../views/operate-center/message-ad/message-notification/Add.vue"),
      },
      {
        path: "/operate-center/message-ad/message-notification/edit",
        name: "operate-center-message-ad-message-notification-edit",
        component: () => import("../views/operate-center/message-ad/message-notification/Add.vue"),
      },
      {
        path: "/operate-center/message-ad/message-notification/view",
        name: "operate-center-message-ad-message-notification-view",
        component: () => import("../views/operate-center/message-ad/message-notification/View.vue"),
      },
      //活动管理
      {
        path: "/operate-center/activity-manage/task-manage/list",
        name: "operate-center-activity-manage-task-manage-list",
        component: () => import("../views/operate-center/activity-manage/task-manage/List.vue"),
      },
      {
        path: "/operate-center/activity-manage/task-manage/add",
        name: "operate-center-activity-manage-task-manage-add",
        component: () => import("../views/operate-center/activity-manage/task-manage/Add.vue"),
      },
      {
        path: "/operate-center/activity-manage/task-manage/edit",
        name: "operate-center-activity-manage-task-manage-edit",
        component: () => import("../views/operate-center/activity-manage/task-manage/Add.vue"),
      },
      {
        path: "/operate-center/activity-manage/task-manage/view",
        name: "operate-center-activity-manage-task-manage-view",
        component: () => import("../views/operate-center/activity-manage/task-manage/View.vue"),
      },
      {
        path: "/operate-center/activity-manage/task-manage/view-register",
        name: "operate-center-activity-manage-task-manage-view-register",
        component: () => import("../views/operate-center/activity-manage/task-manage/View-register.vue"),
      },

      // 内容管理
      {
        path: "/operate-center/content-manage/sell-material/list",
        name: "operate-center-content-manage-sell-material-list",
        component: () => import("../views/operate-center/content-manage/sell-material/List.vue"),
      },
      {
        path: "/operate-center/content-manage/sell-material/add",
        name: "operate-center-content-manage-sell-material-add",
        component: () => import("../views/operate-center/content-manage/sell-material/Add.vue"),
      },
      {
        path: "/operate-center/content-manage/sell-material/edit",
        name: "operate-center-content-manage-sell-material-edit",
        component: () => import("../views/operate-center/content-manage/sell-material/Add.vue"),
      },
      {
        path: "/operate-center/content-manage/article/list",
        name: "operate-center-content-manage-article-list",
        component: () => import("../views/operate-center/content-manage/article/List.vue"),
      },
      {
        path: "/operate-center/content-manage/article/add",
        name: "operate-center-content-manage-article-add",
        component: () => import("../views/operate-center/content-manage/article/Add.vue"),
      },
      {
        path: "/operate-center/content-manage/article/edit",
        name: "operate-center-content-manage-article-edit",
        component: () => import("../views/operate-center/content-manage/article/Add.vue"),
      },

      {
        path: "/operate-center/content-manage/ad-material/list",
        name: "operate-center-content-manage-ad-material-list",
        component: () => import("../views/operate-center/content-manage/ad-material/List.vue"),
      },
      {
        path: "/operate-center/content-manage/ad-material/add",
        name: "operate-center-content-manage-ad-material-add",
        component: () => import("../views/operate-center/content-manage/ad-material/Add.vue"),
      },
      {
        path: "/operate-center/content-manage/ad-material/edit",
        name: "operate-center-content-manage-ad-material-edit",
        component: () => import("../views/operate-center/content-manage/ad-material/Add.vue"),
      },
      //数字人管理
      {
        path: "/operate-center/content-manage/virtual-human/list",
        name: "operate-center-content-manage-virtual-human-list",
        component: () => import("../views/operate-center/content-manage/virtual-human/List.vue"),
      },
      //超级店员管理
      {
        path: "/operate-center/content-manage/super-assistant/list",
        name: "operate-center-content-manage-super-assistant-list",
        component: () => import("../views/operate-center/content-manage/super-assistant/List.vue"),
      },
      //AI素材
      {
        path: "/operate-center/content-manage/AI-material/list",
        name: "operate-center-content-manage-AI-material-list",
        component: () => import("../views/operate-center/content-manage/AI-material/List.vue"),
      },
      //连锁提现
      {
        path: "/operate-center/financial-manage/chain-withdrawal/list",
        name: "operate-center-financial-manage-chain-withdrawal-list",
        component: () => import("../views/operate-center/financial-manage/chain-withdrawal/List.vue"),
      },
      {
        path: "/operate-center/financial-manage/chain-withdrawal/add",
        name: "operate-center-financial-manage-chain-withdrawal-add",
        component: () => import("../views/operate-center/financial-manage/chain-withdrawal/Add.vue"),
      },

      // 个人收支
      {
        path: "/operate-center/financial-manage/personal-revenue/list",
        name: "operate-center-financial-manage-personal-revenue-list",
        component: () => import("../views/operate-center/financial-manage/personal-revenue/List.vue"),
      },
      // 订单收益
      {
        path: "/operate-center/financial-manage/order-revenue/list",
        name: "operate-center-financial-manage-order-revenue-list",
        component: () => import("../views/operate-center/financial-manage/order-revenue/List.vue"),
      },
      // 返利
      {
        path: "/operate-center/financial-manage/rebate/list",
        name: "operate-center-financial-manage-rebate-list",
        component: () => import("../views/operate-center/financial-manage/rebate/List.vue"),
      },
      {
        path: "/operate-center/financial-manage/rebate/add",
        name: "operate-center-financial-manage-rebate-add",
        component: () => import("../views/operate-center/financial-manage/rebate/Add.vue"),
      },
      {
        path: "/operate-center/financial-manage/rebate/edit",
        name: "operate-center-financial-manage-rebate-edit",
        component: () => import("../views/operate-center/financial-manage/rebate/Add.vue"),
      },

      {
        path: "/operate-center/financial-manage/rebate/view",
        name: "operate-center-financial-manage-rebate-view",
        component: () => import("../views/operate-center/financial-manage/rebate/View.vue"),
      },
      //提现明细
      {
        path: "/operate-center/financial-manage/withdrawal-details/list",
        name: "operate-center-financial-manage-withdrawal-details-list",
        component: () => import("../views/operate-center/financial-manage/withdrawal-details/List.vue"),
      },

      {
        path: "/operate-center/financial-manage/withdrawal-details/view",
        name: "operate-center-financial-manage-withdrawal-details-view",
        component: () => import("../views/operate-center/financial-manage/withdrawal-details/View.vue"),
      },
      //对账单
      {
        path: "/operate-center/financial-manage/account-statement/list",
        name: "operate-center-financial-manage-account-statement-list",
        component: () => import("../views/operate-center/financial-manage/account-statement/List.vue"),
      },
      {
        path: "/operate-center/financial-manage/account-statement/view",
        name: "operate-center-financial-manage-account-statement-view",
        component: () => import("../views/operate-center/financial-manage/account-statement/View.vue"),
      },
      {
        path: "/operate-center/financial-manage/account-statement/details",
        name: "operate-center-financial-manage-account-statement-details",
        component: () => import("../views/operate-center/financial-manage/account-statement/Details.vue"),
      },
      //报表管理
      {
        path: "/operate-center/report-mana/shop-visit/list",
        name: "operate-center-report-mana-shop-visit-list",
        component: () => import("../views/operate-center/report-mana/shop-visit/List.vue"),
      },
      {
        path: "/operate-center/report-mana/shop-visit/view",
        name: "operate-center-report-mana-shop-visit-view",
        component: () => import("../views/operate-center/report-mana/shop-visit/View.vue"),
      },

      {
        path: "/operate-center/report-mana/material/list",
        name: "operate-center-report-mana-material-list",
        component: () => import("../views/operate-center/report-mana/material/List.vue"),
      },
      {
        path: "/operate-center/report-mana/protocol/list",
        name: "operate-center-report-mana-protocol-list",
        component: () => import("../views/operate-center/report-mana/protocol/List.vue"),
      },
      {
        path: "/operate-center/report-mana/call/list",
        name: "operate-center-report-mana-call-list",
        component: () => import("../views/operate-center/report-mana/call/List.vue"),
      },
      {
        path: "/operate-center/report-mana/activity-registration/list",
        name: "operate-center-report-mana-activity-registration-list",
        component: () => import("../views/operate-center/report-mana/activity-registration/List.vue"),
      },
      {
        path: "/operate-center/report-mana/activity-diagnostic/list",
        name: "operate-center-report-mana-activity-diagnostic-list",
        component: () => import("../views/operate-center/report-mana/activity-diagnostic/List.vue"),
      },
      {
        path: "/operate-center/report-mana/shop-detail/list",
        name: "operate-center-report-mana-shop-detail-list",
        component: () => import("../views/operate-center/report-mana/shop-detail/List.vue"),
      },
      {
        path: "/operate-center/report-mana/shop-detail/view",
        name: "operate-center-report-mana-shop-detail-view",
        component: () => import("../views/operate-center/report-mana/shop-detail/View.vue"),
      },
      {
        path: "/operate-center/report-mana/shop-activityrate/list",
        name: "operate-center-report-mana-shop-activityrate-list",
        component: () => import("../views/operate-center/report-mana/shop-activityrate/List.vue"),
      },
      {
        path: "/operate-center/report-mana/agreement/list",
        name: "operate-center-report-mana-agreement-list",
        component: () => import("../views/operate-center/report-mana/agreement/List.vue"),
      },

      //直播列表
      {
        path: "/operate-center/live-broadcast/live-manage/list",
        name: "operate-center-live-broadcast-live-manage-list",
        component: () => import("../views/operate-center/live-broadcast/live-manage/List.vue"),
      },
      {
        path: "/operate-center/live-broadcast/live-manage/view",
        name: "operate-center-live-broadcast-live-manage-view",
        component: () => import("../views/operate-center/live-broadcast/live-manage/View.vue"),
      },
      {
        path: "/operate-center/live-broadcast/live-manage/add",
        name: "operate-center-live-broadcast-live-manage-add",
        component: () => import("../views/operate-center/live-broadcast/live-manage/Add.vue"),
      },
      {
        path: "/operate-center/live-broadcast/live-manage/edit",
        name: "operate-center-live-broadcast-live-manage-edit",
        component: () => import("../views/operate-center/live-broadcast/live-manage/Add.vue"),
      },
      //主播列表
      {
        path: "/operate-center/live-broadcast/anchor/list",
        name: "operate-center-live-broadcast-anchor-list",
        component: () => import("../views/operate-center/live-broadcast/anchor/List.vue"),
      },

      //扫码出库
      {
        path: "/operate-center/shop-task/scan-code/list",
        name: "operate-center-shop-task-scan-code-list",
        component: () => import("../views/operate-center/shop-task/scan-code/List.vue"),
      },
      {
        path: "/operate-center/shop-task/scan-code/view",
        name: "operate-center-shop-task-scan-code-view",
        component: () => import("../views/operate-center/shop-task/scan-code/View.vue"),
      },
      //呆鸟学堂报表
      {
        path: "/operate-center/nutrition-classroom/nutrition/list",
        name: "operate-center-nutrition-classroom-nutrition-list",
        component: () => import("../views/operate-center/nutrition-classroom/nutrition/List.vue"),
      },
      {
        path: "/operate-center/nutrition-classroom/rule/list",
        name: "operate-center-nutrition-classroom-rule-list",
        component: () => import("../views/operate-center/nutrition-classroom/rule/List.vue"),
      },
      {
        path: "/operate-center/nutrition-classroom/rule/add",
        name: "operate-center-nutrition-classroom-rule-add",
        component: () => import("../views/operate-center/nutrition-classroom/rule/Add.vue"),
      },
      {
        path: "/operate-center/nutrition-classroom/rule/edit",
        name: "operate-center-nutrition-classroom-rule-edit",
        component: () => import("../views/operate-center/nutrition-classroom/rule/Add.vue"),
      },
      {
        path: "/operate-center/nutrition-classroom/rule/view",
        name: "operate-center-nutrition-classroom-rule-view",
        component: () => import("../views/operate-center/nutrition-classroom/rule/View.vue"),
      },

      //充值管理
      {
        path: "/operate-center/financial-manage/charge-mana/list",
        name: "financial-manage-charge-mana-list",
        component: () => import("../views/operate-center/financial-manage/charge-mana/List.vue"),
      },
      {
        path: "/operate-center/financial-manage/charge-mana/add",
        name: "financial-manage-charge-mana-add",
        component: () => import("../views/operate-center/financial-manage/charge-mana/Add.vue"),
      },

      {
        path: "/operate-center/financial-manage/charge-mana/charge-log/list",
        name: "financial-manage-charge-mana-charge-log-list",
        component: () => import("../views/operate-center/financial-manage/charge-mana/charge-log/List.vue"),
      },

      {
        path: "/operate-center/financial-manage/charge-mana/charge-log/view",
        name: "financial-manage-charge-mana-charge-log-view",
        component: () => import("../views/operate-center/financial-manage/charge-mana/charge-log/View.vue"),
      },

      /*************** #end 运营中心 *********************/
      /*************** #start 数据中心 *********************/
      {
        path: "/data-center/history-data/order/list",
        name: "data-center-history-data-order-list",
        component: () => import("../views/data-center/history-data/order/List.vue"),
      },
      {
        path: "/data-center/history-data/order/view",
        name: "data-center-history-data-order-view",
        component: () => import("../views/data-center/history-data/order/View.vue"),
      },
      {
        path: "/data-center/history-data/withdraw/list",
        name: "data-center-history-data-withdraw-list",
        component: () => import("../views/data-center/history-data/withdraw/List.vue"),
      },
      {
        path: "/data-center/history-data/withdraw/view",
        name: "data-center-history-data-withdraw-view",
        component: () => import("../views/data-center/history-data/withdraw/View.vue"),
      },

      /*************** #end 数据中心 *********************/
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
